module.exports = __webpack_public_path__ + "static/media/emailLogo.8b1d4bba.png";